import {Component, OnInit} from '@angular/core';
import {ProAnalise} from "../../../../types/ProAnalise.type";
import {ProanaliseService} from "../../../../services/proanalise.service";
import {ToastService} from "../../../../services/toast.service";
import {ProAtributo} from "../../../../types/ProAtributo.type";
import {ProatributoService} from "../../../../services/proatributo.service";

@Component({
  selector: 'app-analises',
  templateUrl: './proanalises.component.html',
  styleUrl: './proanalises.component.css'
})
export class ProanalisesComponent implements OnInit {

  analises: ProAnalise[] = []
  analise!: ProAnalise;
  loading: boolean = false;
  formDialog: boolean = false;

  constructor(private proAnaliseService: ProanaliseService, private toastService: ToastService, private proAtributoService: ProatributoService) {
  }

  status: any[] = [{name: 'PENDENTE', value: 'PENDENTE'}
    , {name: 'PARCIAL', value: 'PARCIAL'}
    , {name: 'ERRO', value: 'ERRO'}
    , {name: 'INTEGRADO', value: 'INTEGRADO'}
  ]

  ngOnInit() {
    this.buscaAnalises();
  }

  buscaAnalises() {

    this.loading = true;
    this.proAnaliseService.getAnalises().subscribe({
      next: data => {
        this.analises = data;
      },
      error: error => {
        this.toastService.erro("Erro", "Erro ao buscas as analises.")
        this.loading = false;
      },
      complete: () => {
        this.loading = false;
      }
    })
  }

  getSeverity(status: string): string {

    switch (status) {
      case 'PENDENTE':
        return 'primary';
      case 'ERRO':
        return 'danger';
      case 'PARCIAL':
        return 'warning'
      case 'INTEGRADO':
        return 'success';
      default:
        return 'primary';
    }


  }

  carregaAtributos(analise: ProAnalise) {
    this.formDialog = true;

    this.proAnaliseService.getAnalise(analise.id).subscribe({
      next: data => {
        this.analise = data;
      },
      error: error => {

      }
    })

  }

  esconderDialogo() {
    this.formDialog = false;
  }

}
